var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuNoticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#F0EEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 31.9375V8.0625H31.9375V31.9375H8.0625Z",
    stroke: "#666666",
    strokeWidth: 0.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29H23",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2686 17.7499C13.2673 16.8605 13.4421 15.9795 13.7829 15.1579C14.1238 14.3363 14.6238 13.5903 15.2543 12.9628C15.8848 12.3353 16.6332 11.8389 17.4564 11.502C18.2797 11.1652 19.1615 10.9946 20.0509 11.0001C23.7625 11.0277 26.7312 14.1128 26.7312 17.8347V18.4999C26.7312 21.8577 27.4337 23.8061 28.0524 24.871C28.1191 24.9848 28.1546 25.1142 28.1553 25.246C28.156 25.3779 28.1219 25.5076 28.0565 25.6221C27.991 25.7366 27.8966 25.8318 27.7826 25.8982C27.6686 25.9645 27.5392 25.9996 27.4073 25.9999H12.5917C12.4598 25.9996 12.3304 25.9645 12.2164 25.8981C12.1024 25.8318 12.0079 25.7366 11.9425 25.622C11.8771 25.5075 11.843 25.3778 11.8438 25.2459C11.8445 25.114 11.88 24.9846 11.9467 24.8709C12.5657 23.8059 13.2685 21.8575 13.2685 18.4999L13.2686 17.7499Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNoticeIcon);
export default __webpack_public_path__ + "static/media/menu-notice-icon.8dc43a6b647cecf30162317dac528bfb.svg";
export { ForwardRef as ReactComponent };